<template>
  <div>
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Meeting</h3>
        <div class="h4">表格標題區域</div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Meeting</h4>
          </div>

          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="content.table_title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Session</h3>
        <div class="h4">
          至少需一組會期<br />
          可添加欄位做內容填充
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5" v-for="(item, i) in content.sections" :key="i">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Session</h4>
            <button
              v-if="i > 0"
              class="btn btn-danger square w-32px h-32px"
              @click="deleteItem(i)"
            >
              <v-icon color="white">delete</v-icon>
            </button>
          </div>

          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="item.title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>

          <!-- Date -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Date</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="item.date"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>

          <!-- Item -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Item</h4>
            <div class="my-n2 flex-grow-1">
              <editor
                :key="`${item.title}${i}`"
                v-model="item.description"
                :height="200"
                :plugins="'lists link bold'"
                :toolbar="'link bold bullist numlist'">
              </editor>
            </div>
          </label>
        </div>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="$emit('addItem')">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content</span>
          </button>
        </div>
        <div class="page-actions">
          <v-spacer></v-spacer>
          <button class="btn mr-5" @click="$emit('cancelHandler')">
            <span>取消</span>
          </button>
          <button class="btn btn-primary" @click="$emit('saveHandler')">
            <span>儲存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@/components/TinymceEditor.vue';

export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    dateMenu: false,
  }),
  components: {
    Editor,
  },
  methods: {
    deleteItem(index) {
      this.content.sections.splice(index, 1);
    },
  },
};
</script>

<style></style>
